/** User-facing message for failed API calls (login, etc.). */

function isLocalFrontend() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

function productionApiHint() {
  const api =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    "";

  if (api && api.startsWith("http")) {
    try {
      return new URL(api.replace(/\/api\/?$/, "") || api).origin;
    } catch (_err) {
      return api;
    }
  }

  if (typeof window !== "undefined" && !isLocalFrontend()) {
    return window.location.origin;
  }

  return "http://localhost:5001";
}

function unreachableMessage() {
  if (isLocalFrontend()) {
    return (
      "Cannot reach the backend. Start it on port 5001, then try again."
    );
  }

  return (
    `Cannot reach the API server (${productionApiHint()}). ` +
    "Please check that the backend server is running."
  );
}

/** User-facing message for failed API calls (login, etc.). */
export function getApiErrorMessage(err, fallback = "Request failed") {
  const status = err?.response?.status;
  const data = err?.response?.data;

  if (typeof data === "string" && data.trim()) {
    if (/<!DOCTYPE html|<html/i.test(data)) {
      if (status === 404) {
        return "The OTP API route is not available on the backend (404). Restart the backend server and try again.";
      }
      if (status === 502) {
        return `Backend unavailable (502) at ${productionApiHint()}.`;
      }
      return fallback;
    }
    return data;
  }

  if (data?.message) {
    if (/Custom Id cannot be integers/i.test(String(data.message))) {
      return "Upload could not be queued. Restart the backend on port 5001 so numeric batch ids use prefixed queue job ids, then click Start upload once.";
    }
    return data.message;
  }

  if (status === 500 && /^500(\s+Internal Server Error)?$/i.test(String(err?.message || "").trim())) {
    return "The server hit an unexpected error. Please try again.";
  }

  if (
    (status === 503 || status === 504 || status === 502 || err?.code === "ECONNABORTED") &&
    !data?.message
  ) {
    return unreachableMessage();
  }

  if (err?.message === "Network Error" || err?.code === "ERR_NETWORK") {
    return unreachableMessage();
  }

  return err?.message || fallback;
}
